import Api, { urlBase } from "./Api";

const clienteApi = () =>
  Api({
    tokenKey: "cliente_token",
    redirectOnUnauthorized: false,
  });

export default {
  registrar(datos) {
    return clienteApi().post(
      "/clientes/auth/register",
      datos
    );
  },

  login(datos) {
    return clienteApi().post(
      "/clientes/auth/login",
      datos
    );
  },

  loginConGoogle() {
    window.location.href =
      `${urlBase}/clientes/auth/google/redirect`;
  },

  obtenerPerfil() {
    return clienteApi().get(
      "/clientes/auth/me"
    );
  },

  actualizarPerfil(datos) {
    return clienteApi().put(
      "/clientes/auth/me",
      datos
    );
  },
  
  logout() {
    return clienteApi().post(
      "/clientes/auth/logout"
    );
  },
};